import { render } from "./admin-access-page.vue?vue&type=template&id=193099b3&scoped=true"
import script from "./admin-access-page.vue?vue&type=script&lang=js"
export * from "./admin-access-page.vue?vue&type=script&lang=js"

import "./admin-access-page.vue?vue&type=style&index=0&id=193099b3&lang=scss&scoped=true"
import "./admin-access-page.vue?vue&type=style&index=1&id=193099b3&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-193099b3"]])

export default __exports__